/**
 * Spec 10.2.1 — content-hash affordance. Click-to-reveal; the full hash is NEVER
 * printed as body text (design-rules: the hash is evidence, not prose).
 */
import { useState } from "react";
import { shortHash } from "./format";

export function HashChip({ hash }: { hash: string }) {
  const [open, setOpen] = useState(false);
  return (
    <button
      type="button"
      className="hash-chip"
      title={open ? "Hide content hash" : "Reveal content hash"}
      onClick={(e) => {
        e.stopPropagation();
        setOpen((v) => !v);
      }}
    >
      {open ? hash : shortHash(hash)}
    </button>
  );
}
